export default __webpack_public_path__ + "static/media/cucumber.59f77c0a.svg";